import React, {useEffect} from 'react'
import {useCheckboxDropdownPublish} from './CheckboxDropdownContext'

type TOption = {label: string; value: string | number; menu_label: string}

type TCheckboxDropdown = {
    options: TOption[]
    formValue: any
    placeholder?: string
    isMulti?: boolean
    isDisabled?: boolean
    isLoading?: boolean
    isError?: boolean
    error?: string
    handleChange: (value: any) => void
}

const CheckboxDropdown: React.FC<TCheckboxDropdown> = ({
    options,
    formValue,
    isMulti,
    isDisabled,
    isLoading,
    isError,
    error,
    handleChange,
}) => {
    const selectedValues = new Set<string>(
        Array.isArray(formValue)
            ? formValue.map(String)
            : formValue != null
            ? [String(formValue)]
            : []
    )

    const selectedOptions = options.filter((o) => selectedValues.has(String(o.value)))

    const handleToggle = (option: TOption) => {
        if (isDisabled) return
        if (isMulti) {
            const isSelected = selectedValues.has(String(option.value))
            const newValue = isSelected
                ? selectedOptions.filter((o) => String(o.value) !== String(option.value))
                : [...selectedOptions, option]
            handleChange(newValue.length ? newValue : null)
        } else {
            const isSelected = selectedValues.has(String(option.value))
            handleChange(isSelected ? null : option)
        }
    }

    const allSelected = options.length > 0 && options.every((o) => selectedValues.has(String(o.value)))

    const handleToggleAll = () => {
        if (isDisabled) return
        handleChange(allSelected ? null : options)
    }

    const publish = useCheckboxDropdownPublish()
    useEffect(() => {
        publish?.({allSelected, toggleAll: handleToggleAll})
    })

    if (isLoading) {
        return <div className='checkboxList_loading'>Загрузка...</div>
    }

    return (
        <div className={`checkboxList${isDisabled ? ' checkboxList--disabled' : ''}${isError ? ' checkboxList--error' : ''}`}>
            {options.length === 0 ? (
                <div className='checkboxList_empty'>Нет вариантов</div>
            ) : (
                <>
                {options.map((option) => {
                    const isChecked = selectedValues.has(String(option.value))
                    return (
                        <div
                            key={option.value}
                            className={`checkboxList_option${isChecked ? ' selected' : ''}`}
                            onClick={() => handleToggle(option)}
                        >
                            <input
                                type='checkbox'
                                checked={isChecked}
                                onChange={() => {}}
                                className='checkboxList_checkbox'
                            />
                            <span className='checkboxList_label'>{option.menu_label}</span>
                        </div>
                    )
                })}
                </>
            )}
            {isError && <div className='invalid_feedback'>{error}</div>}
        </div>
    )
}

export default CheckboxDropdown